import React, { useState, useEffect } from "react"
import "./index.scss"
import { NavigationLink, Slug } from "@utils/globalTypes"
import { Link } from "gatsby"
import brandLigth from "@assets/svg/Birchbrook_Icon_Lavender.svg"
import NavCarrotGray from "@assets/svg/NavDownCarrot"
import Img from "react-bootstrap/Image"
import useResizeWidth from "@hooks/useResizeWidth"
import { Dropdown } from "react-bootstrap"

type Props = {
  links: NavigationLink
  slug: Slug
  style?: any
  isSection?: boolean
}

const isBrowser = typeof window !== "undefined"

const LateralNavigation = ({
  links,
  slug,
  style = {},
  isSection = true,
}: Props) => {
  const { width } = useResizeWidth()
  const [current, setCurrent] = useState("")

  useEffect(() => {
    if (isBrowser) {
      setCurrent(
        links.childs.find(
          (item) =>
            item.slug.current ===
            `${isSection ? "#" : "/"}${window?.location?.href
              ?.split(isSection ? "#" : "/")
              ?.pop()}`
        )?.title || isSection
          ? "Skip to..."
          : links?.childs[0]?.title
      )
    }
  }, [])

  return width > 960 ? (
    <div className="lateral-nav-container" style={style}>
      <Img src={brandLigth} alt="birchbrook" />
      {links?.childs.map((item, index) => (
        <Link
          key={index}
          to={`${links?.slug?.current}${item?.slug?.current}`}
          className={`${
            `${isSection ? "#" : "/"}${window?.location?.href
              ?.split(isSection ? "#" : "/")
              ?.pop()}` === item?.slug?.current
              ? "active-url"
              : ""
          }`}
        >
          {" "}
          {item?.title}{" "}
        </Link>
      ))}
    </div>
  ) : (
    <Dropdown className="hwh-lateral-dropdown">
      <Dropdown.Toggle
        className="hwh-lateral-dropdown-toggle"
        as={"button"}
        variant="none"
        id="dropdown-basic"
      >
        {current}
        <NavCarrotGray />
      </Dropdown.Toggle>

      <Dropdown.Menu className="hwh-lateral-dropdown-menu">
        {links?.childs.map((item, index) => (
          <Dropdown.Item
            as={Link}
            to={`${links?.slug?.current}${item?.slug?.current}`}
            key={index}
          >
            {item?.title}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default LateralNavigation
